import { Injectable } from '@angular/core';
function _window(): any {
    // return the global native browser window object
    return window;
}

@Injectable({
    providedIn: 'root'
})

export class WindowRefService {
    get nativeWindow(): any {
        return _window();
    }

    public ln = 'en';

    constructor() {
        try {
            if (this.nativeWindow.navigator.language !== null && this.nativeWindow.navigator.language !== undefined && this.nativeWindow.navigator.language !== '') {
                this.ln = this.nativeWindow.navigator.language;
            }

        } finally { }
    }
}
